import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
}

/**
 * DS page header — mirrors mockup `.page-header` / `.page-title` / `.page-subtitle`:
 * LEFT-aligned title (display font, 2xl, -0.02em) + optional subtitle, with an
 * optional action pinned to the RIGHT. Never centered.
 */
export const PageHeader = ({ title, subtitle, action }: PageHeaderProps) => (
  <Flex align='flex-start' justify='space-between' wrap='wrap' gap={3} mb={6}>
    <Box minW={0}>
      <Heading
        as='h1'
        color='text.default'
        fontFamily='heading'
        fontSize='2xl'
        fontWeight={600}
        letterSpacing='-0.02em'
      >
        {title}
      </Heading>
      {subtitle && (
        <Text mt={1} color='text.muted' fontSize='sm'>
          {subtitle}
        </Text>
      )}
    </Box>
    {action && <Box flexShrink={0}>{action}</Box>}
  </Flex>
);

export default PageHeader;
